import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
var formatTimeForDisplay = function formatTimeForDisplay(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fr-FR';
  return new Date(date).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit'
  });
};
var formatOpeningScheduleForDisplay = function formatOpeningScheduleForDisplay(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fr-FR';
  if (day.first_start_time && day.first_close_time) {
    return "".concat(formatTimeForDisplay(day.first_start_time, locale), " - ").concat(formatTimeForDisplay(day.first_close_time, locale));
  }
  return '';
};
var formatDateForArticle = (date, locale) => {
  if (!date) return null;
  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};
var formatDateYearMonthDay = date => {
  if (!date) return null;
  return new Date(date).toISOString().replace('-', '').split('T')[0].replace('-', '');
};
export { formatTimeForDisplay, formatOpeningScheduleForDisplay, formatDateForArticle, formatDateYearMonthDay };